import { EntityPreviewLink } from '@/features/preview/EntityPreviewLink'
import { type AdminAccountPage, adminRoutes } from '@/routes'

type Props = {
  _id: string
  name?: string
  subPage?: AdminAccountPage
}

export const AccountLink = ({ _id, name, subPage }: Props) => (
  <EntityPreviewLink
    type="account"
    _id={_id}
    name={name}
    to={adminRoutes.accountPage(_id, subPage)}
  />
)
